import { Button, Grid } from "@mui/material";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getEstablecimientos } from "../../../redux/actions/examenesPeriodicos";
import FormikAutocomplete from "../../commons/formik/FormikAutocomplete";
import { StyledExamenesPeriodicos } from "../../styled/ExamenesPeriodicos";
import InputLabel from "../commons/InputLabel";

const initialValues = {
  idEstablecimiento: "",
  fechaDesde: null,
  fechaHasta: null,
};

const validationSchema = Yup.object().shape({
  idEstablecimiento: Yup.string().required("Campo Obligatorio").nullable(),
  fechaDesde: Yup.date()
    .nullable()
    .typeError("Fecha inválida")
    .required("Campo obligatorio")
    .test({
      name: "fechaDesde",
      message: "La fecha desde debe ser menor o igual a la fecha hasta",
      test: function (value) {
        if (value <= this.parent.fechaHasta) {
          return true;
        }
        return false;
      },
    }),

  fechaHasta: Yup.date()
    .nullable()
    .typeError("Fecha inválida")
    .required("Campo obligatorio")
    .test({
      name: "fechaHasta",
      message: "La fecha hasta debe ser mayor o igual a la fecha desde",
      test: function (value) {
        if (value >= this.parent.fechaDesde) {
          return true;
        }
        return false;
      },
    }),
});

const SearchLoteForm = ({ handleSubmit }) => {
  const dispatch = useDispatch();

  const previousSearch = useSelector(
    (state) => state.examenesPeriodicos.searchParams
  );
  const establecimientos = useSelector(
    (state) => state.examenesPeriodicos.establecimientos.data
  );
  const isLoadingDatosEstablecimiento = useSelector(
    (state) => state.examenesPeriodicos.datosEstablecimiento.loading
  );
  const isLoadingLotes = useSelector(
    (state) => state.examenesPeriodicos.lotesExamenesPeriodicos.loading
  );

  // Cuando el usuario apreta el botón de "Buscar", se disparan
  // dos búsquedas. Por especificación del analista, es necesario
  //  deshabilitar el botón a menos que estas se completen (o fallen).
  const isBuscando = isLoadingDatosEstablecimiento || isLoadingLotes;

  return (
    <Formik
      initialValues={previousSearch ?? initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <StyledExamenesPeriodicos.Form>
          <StyledExamenesPeriodicos.Grid container spacing={2}>
            <Grid item xs={6}>
              <InputLabel title="Establecimiento" />
              <FormikAutocomplete
                sx={{ marginTop: "30px" }}
                name="idEstablecimiento"
                label="Establecimiento *"
                variant="standard"
                options={establecimientos}
                getOptions={() => dispatch(getEstablecimientos())}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel title="Período" />
              <StyledExamenesPeriodicos.DatesContainer>
                <StyledExamenesPeriodicos.DateInput
                  name="fechaDesde"
                  label="Desde *"
                />
                <StyledExamenesPeriodicos.DateInput
                  name="fechaHasta"
                  label="Hasta *"
                />
              </StyledExamenesPeriodicos.DatesContainer>
            </Grid>
            <Grid item>
              <StyledExamenesPeriodicos.ButtonContainer>
                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={
                    values.fechaDesde == null ||
                    values.fechaHasta == null ||
                    isBuscando
                  }
                >
                  {!isBuscando ? "Buscar" : "Cargando..."}
                </Button>
              </StyledExamenesPeriodicos.ButtonContainer>
            </Grid>
          </StyledExamenesPeriodicos.Grid>
        </StyledExamenesPeriodicos.Form>
      )}
    </Formik>
  );
};

export default SearchLoteForm;
